document.addEventListener('DOMContentLoaded', function() {
  function handleIntercomLinks() {
    let links = document.querySelectorAll('.open-contact');
    
    if (links.length > 0) {
      links.forEach(link => {
        // Remove listeners
        link.removeEventListener('click', handleClick, true);
        //add new listener
        link.addEventListener('click', handleClick, true);
      });
    }
  }

  function handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    
    // Use  API  Intercom directly
    if (window.Intercom) {
      window.Intercom('show');
    } else {
      // Fallback to previous method if API is not available
      const intercomLauncher = document.querySelector('.intercom-lightweight-app-launcher-icon');
      if (intercomLauncher) {
        intercomLauncher.click();
      }
    }
    return false;
  }

  handleIntercomLinks();

});
